import { useDashboard } from 'providers/Auth';

import { useLang } from 'locale';

import { Box, Card, Collapse, Column, Row } from 'components/Blocks';
import { Coin } from 'components/DecorativeIcons';
import { ChevronRightIcon, TrophyIcon } from 'components/Blocks/Icons';
import { getAvailableRewards } from 'components/Rewards';

import { useToggleV2, useWindowSize } from 'hooks';
import { cn } from 'styles';

export function RewardList() {
  const { t } = useLang();

  const { breakpoints } = useWindowSize();

  const [isExpanded, expandHandlers] = useToggleV2();

  const [{ user }] = useDashboard();

  const isMobileView = breakpoints.SMALL_TABLET;

  return (
    <Card flow="column" className="shadow-main" fullWidth>
      {isMobileView && (
        <button className="flex select-none items-center gap-2" onClick={expandHandlers.toggle}>
          <Box className="rounded-full bg-primary/5 p-1.5 text-primary">
            <TrophyIcon size={18} />
          </Box>

          <span className="text-sm font-semibold">{t('activity-history')}</span>

          <ChevronRightIcon
            size={20}
            className={cn('ml-auto text-primary transition-transform', isExpanded && 'rotate-90')}
          />
        </button>
      )}

      <Collapse onlyRenderIfExpanded expanded={!isMobileView || isExpanded}>
        <Column fullWidth className={cn(isMobileView && 'px-2 pt-2')}>
          {getAvailableRewards(user.country).map(({ description, name, value, icon, points }) => (
            <Column
              gap="1"
              key={name}
              className="border-b-[0.5px] pb-3 text-sm last-of-type:border-b-0 last-of-type:pb-0"
            >
              <Row justifyContent="space-between">
                <Row gap="2">
                  {icon}

                  <span className="font-medium text-foreground-title">{t(name)}</span>
                </Row>

                <Row gap="2">
                  <span className="mr-4 font-semibold">{value[user.country]}</span>

                  <Coin size={20} />

                  <strong>{points}</strong>
                </Row>
              </Row>

              <p className="text-foreground-light">
                {typeof description === 'string' ? t(description) : description[user.country]}
              </p>
            </Column>
          ))}
        </Column>
      </Collapse>
    </Card>
  );
}
